// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { backlogsManifest } from './backlogs';
import { calendarManifest } from './calendar';
import { issuesManifest } from './issues';
import { okrManifest } from './okr';
import { projectsManifest } from './projects';
import { risksManifest } from './risks';
import { tasksManifest } from './tasks';
import { timeTrackingManifest } from './time-tracking';

/** Група модулів «Управління» (Management): 8 модулів. */
export const managementGroup: IModuleGroupManifest = {
  key: 'management',
  category: 'Management',
  name: { en: 'Management', uk: 'Управління' },
  sort: 2,
  modules: [backlogsManifest, calendarManifest, issuesManifest, okrManifest, projectsManifest, risksManifest, tasksManifest, timeTrackingManifest],
};
